<template>
  <div class="cta-detail-leaflet">
    <div
      class="img-container-leaflet d-flex flex-column justify-center align-center"
      style="position:relative"
      v-if="areaDetail.metadata?.leafletareatype_cta?.IMAGE?.location"
    >
      <div>
        <img
          class="image image-leaflet"
          :src="`${areaDetail.metadata?.leafletareatype_cta?.IMAGE?.location}`"
        />
      </div>
    </div>
    <div v-else class="product-list-cta-slider slider pa-4">
      <swiper :options="swiperOption" ref="swiperCtaRef">
        <swiper-slide
          v-for="(product, index) in products"
          v-bind:key="product.productId"
        >
          <div class="mb-2">
            <span class="product-name grey--text--darken-1">{{
              product.name
            }}</span>
          </div>
          <v-tabs
            v-model="tab[index]"
            icons-and-text
            background-color="secondary lighten-1"
            center-active
            slider-size="3"
            height="60"
            active-class="selected-tab"
            class="secondary product-leaflet-tabs"
          >
            <v-tab href="#product" value="product" class="mt-0"
              ><span
                class="font-weight-bold caption mb-0 pt-1 secondary--text"
                >{{ $t("leaflet.productDetail.product") }}</span
              >
              <img class="circle-icon" src="/img/prodotto.svg" />
            </v-tab>
            <v-tab
              v-if="showMetadata(product) && videoURl(product)"
              href="#play"
              value="play"
              class="mt-0"
              ><span
                class="font-weight-bold caption mb-0 pt-1 secondary--text"
                >{{ $t("leaflet.productDetail.video") }}</span
              ><img class="circle-icon" src="/img/video 1.svg"
            /></v-tab>
            <v-tab
              v-if="showMetadata(product) && showInfoTab(product)"
              href="#info"
              value="info"
              class="mt-0"
            >
              <span
                class="font-weight-bold caption mb-0 pt-1 secondary--text"
                >{{ $t("leaflet.productDetail.info") }}</span
              ><img class="circle-icon" src="/img/info 1.svg" />
            </v-tab>
            <v-tab
              v-if="showMetadata(product) && showRecipeTab(product)"
              href="#ricetta"
              value="ricetta"
              class="mt-0"
              ><span
                class="font-weight-bold caption mb-0 pt-1 secondary--text"
                >{{ $t("leaflet.productDetail.recipe") }}</span
              ><img class="circle-icon" src="/img/ricette.svg"
            /></v-tab>
          </v-tabs>
          <v-tabs-items v-model="tab[index]">
            <v-tab-item value="product">
              <ProductDetailLeaflet
                v-bind:product="product"
                @openLink="openLink"
              />
            </v-tab-item>
            <v-tab-item value="play">
              <div class="leaflet-video-wraper">
                <iframe
                  class="leaflet-iframe rounded-sm"
                  :src="videoURl(product)"
                  frameborder="0"
                  allow="accelerometer; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen
                ></iframe>
              </div>
            </v-tab-item>
            <v-tab-item value="info">
              <div class="leaflet-curiosity-wraper pa-3">
                <ebsn-meta
                  :target="product"
                  path="metaData.product_leaflet.INFO"
                  tag="div"
                ></ebsn-meta>
              </div>
            </v-tab-item>
            <v-tab-item value="ricetta">
              <div class="pa-3">
                <ebsn-meta
                  :target="product"
                  path="metaData.product_leaflet.RECIPE"
                  tag="div"
                ></ebsn-meta>
              </div>
            </v-tab-item>
          </v-tabs-items>
        </swiper-slide>
      </swiper>
      <div>
        <div
          :id="`cta-leaflet-button-next-${paginationClass}`"
          class="swiper-button-next cta-leaflet-button-next"
        ></div>
        <div
          :id="`cta-leaflet-button-prev-${paginationClass}`"
          class="swiper-button-prev cta-leaflet-button-prev"
        ></div>
      </div>
    </div>
  </div>
</template>
<style lang="scss">
.product-leaflet-tabs {
  img {
    width: 24px;
  }
  .v-tabs-slider-wrapper {
    top: 0 !important;
    .v-tabs-slider {
      width: 65% !important;
      margin: auto !important;
    }
  }
  .caption {
    font-size: 0.6rem !important;
    line-height: 1rem !important;
  }
  .v-tab {
    padding: 0px !important;
  }
}
.cta-leaflet-button-next,
.cta-leaflet-button-prev {
  top: 280px;
}
.image-leaflet {
  max-width: 100%;
  max-height: 500px;
}
// .actions {
//   margin-top: -25px;
// }
.plus-icon {
  height: 20px !important;
  width: 20px !important;
  padding: 2px;
  font-size: 14px;
  font-weight: bold;
  color: $white !important;
  border-radius: 50%;
  background-color: var(--v-primary-base);
}
.add-to-list {
  position: absolute;
  top: 50px;
  right: 14px;
}
.product-list-cta-slider {
  .product-name {
    font-size: 20px;
    color: var(--v-grey-darken1);
  }
  .v-tabs-slider {
    color: $secondary !important;
  }
  .swiper-container {
    padding: 8px;
  }
  .swiper-pagination {
    bottom: -8px;
    display: flex;
    position: relative;
    justify-content: center;
    .swiper-pagination-bullet {
      background-color: var(--v-primary-lighten2);
    }
  }
  .swiper-button-next:after,
  .swiper-button-prev:after {
    color: #636363;
    font-size: 24px;
    font-weight: bold;
  }
}
.cta_detail_leaflet {
  header {
    height: auto !important;
    padding-top: 8px;
    .mdi-close {
      color: $text-color !important;
    }
  }
}
</style>
<script>
import { mapActions, mapGetters } from "vuex";
// import ProductCard from "@/components/product/ProductCard.vue";
import ProductDetailLeaflet from "@/components/leaflet/ProductDetailLeaflet.vue";

import get from "lodash/get";
import has from "lodash/has";
export default {
  name: "CTADetailLeaflet",
  props: {
    areaDetail: { type: Object, required: true },
    leaflet: { type: Object, required: true },
    position: { type: Number, default: undefined },
    popup: { type: Boolean, default: true },
    icon: { type: String, required: false },
    products: { type: Array, required: false },
    paginationClass: { type: String, required: false },
    cols: { default: 1 },
    sm: { default: 2 },
    md: { default: 3 },
    lg: { default: 4 },
    xl: { default: 6 },
    showArrows: { type: Boolean, default: false },
    showBullets: { type: Boolean, default: true }
  },
  components: { ProductDetailLeaflet },
  mixins: [],
  data() {
    return {
      tab: [],
      activeIndex: 0,
      swiperOption: {
        observer: true,
        slidesPerGroup: 1,
        spaceBetween: 20,
        watchOverflow: true,
        autoplay: false,
        pagination: {
          el: `#product-list-pagination-${this.paginationClass}`,
          clickable: true
        },
        navigation: {
          prevEl: `#cta-leaflet-button-prev-${this.paginationClass}`,
          nextEl: `#cta-leaflet-button-next-${this.paginationClass}`
        },
        breakpoints: {
          0: {
            slidesPerView: this.cols
          },
          600: {
            slidesPerView: this.sm
          },
          960: {
            slidesPerView: this.md
          },
          1264: {
            slidesPerView: this.lg
          },
          1900: {
            slidesPerView: this.xl
          }
        }
      }
    };
  },
  computed: {
    ...mapGetters({
      isAuthenticated: "cart/isAuthenticated"
    })
  },
  methods: {
    openLink() {
      this.$emit("submit", false);
    },
    ...mapActions({ addToList: "custom/addToLeafletList" }),
    addProductToLeafletList() {
      console.log(this.products);
      console.log(this.areaDetail);

      if (get(this.areaDetail, "metadata.leafletareatype_cta.NAME")) {
        this.products[0].name = get(
          this.areaDetail,
          "metadata.leafletareatype_cta.NAME"
        );
      }
      if (get(this.areaDetail, "metadata.leafletareatype_cta.SHORT_DESCR")) {
        this.products[0].shortDescr = get(
          this.areaDetail,
          "metadata.leafletareatype_cta.SHORT_DESCR"
        );
      }
      if (get(this.areaDetail, "metadata.leafletareatype_cta.DESCR")) {
        this.products[0].description = get(
          this.areaDetail,
          "metadata.leafletareatype_cta.DESCR"
        );
      }
      if (
        get(this.areaDetail, "metadata.leafletareatype_cta.IMAGE.location") &&
        this.products[0] &&
        this.products[0].media &&
        this.products[0].media[0].small
      ) {
        this.products[0].media[0].small = get(
          this.areaDetail,
          "metadata.leafletareatype_cta.IMAGE.location"
        );
      }
      this.addToList({ leaflet: this.leaflet, product: this.products[0] });
    },
    loadURL(videoUrl) {
      if (videoUrl) {
        const youtubeEmbedTemplate = "https://www.youtube.com/embed/";
        const vimeoEmbedTemplate = "https://player.vimeo.com/video/";

        const isYouTubeVideo =
          videoUrl.includes("youtube.com") || videoUrl.includes("youtu.be");
        const isVimeoVideo = videoUrl.includes("vimeo.com");

        if (isYouTubeVideo) {
          const url = videoUrl.split(
            /(vi\/|v%3D|v=|\/v\/|youtu\.be\/|\/embed\/)/
          );
          const YId =
            undefined !== url[2] ? url[2].split(/[^0-9a-z_/\\-]/i)[0] : url[0];

          if (YId === url[0]) {
            return videoUrl;
          } else {
            const youtubeEmbedUrl = youtubeEmbedTemplate.concat(YId);
            console.log(youtubeEmbedUrl);
            return youtubeEmbedUrl;
          }
        } else if (isVimeoVideo) {
          const url = videoUrl.split(
            /(https:\/\/(?:vimeo\.com\/|.*\/videos\/))(\d+)/
          );
          const vimeoId = url[2];

          if (vimeoId === url[0]) {
            return videoUrl;
          } else {
            const vimeoEmbedUrl = vimeoEmbedTemplate.concat(vimeoId);
            return vimeoEmbedUrl;
          }
        } else {
          return videoUrl;
        }
      } else {
        return null;
      }
    },

    videoURl(product) {
      return this.loadURL(get(product, "metaData.product_leaflet.VIDEO", null));
    },
    showInfoTab(product) {
      return has(product, "metaData.product_leaflet.INFO");
    },
    showRecipeTab(product) {
      return get(product, "metaData.product_leaflet.RECIPE");
    },
    showMetadata(product) {
      return get(product, "metaData.product_leaflet.SHOW_LEAFLET_METADATA");
    }
  },
  mounted() {
    console.log("swiper");
    let _this = this;
    this.$nextTick(() => {
      setTimeout(() => {
        const swiper = _this.$refs.swiperCtaRef?.swiperInstance;
        if (swiper) {
          swiper.on("slideChange", () => {
            _this.activeIndex = swiper.activeIndex;
          });
          // Force update navigation
          swiper.navigation?.destroy();
          swiper.navigation?.init();
          swiper.navigation?.update();
        } else {
          console.warn("Swiper still undefined");
        }
      }, 100);
    });
  }
};
</script>
